define('bindingHandlers/phoneAddress',[
    'lib/lodash4',
    'lib/knockout',
    'jquery',
    'extensions/i18n/knockout.i18n'
], function (_, ko, $) {
    'use strict';

    /**
     * format an E.164 phone number using phoneNumberFormatter
     *
     * Usage:
     * data-bind="phoneAddress: phoneNumber"
     *
     */
    ko.bindingHandlers.phoneAddress = {
        init: function (element, valueAccessor) {

            var $element = $(element);
            var number = ko.unwrap(valueAccessor());
            $element.html(ko.i18n.formatPhoneAddress(number));
        }
    };
});

